module.exports = require('./dist/app-module/codesplit/universal');
